/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconCursorOff = createReactComponent("cursor-off", "IconCursorOff", [
  ["path", { d: "M9 4a3 3 0 0 1 3 3v1m0 9a3 3 0 0 1 -3 3", key: "svg-0" }],
  ["path", { d: "M15 4a3 3 0 0 0 -3 3v1m0 4v5a3 3 0 0 0 3 3", key: "svg-1" }],
  ["path", { d: "M3 3l18 18", key: "svg-2" }]
]);

export { IconCursorOff as default };
//# sourceMappingURL=IconCursorOff.js.map
